<!-- //
文件日志观测
@author xuyd
@date 2024-08-07
//-->
<template>
  <page-layout layout="A|C">
    <ServerGroup slot="pageAside" ref="refServerGroup" @change="handleGroupChange"/>
    <div style="height: 100%; background-color: #FFFFFF;padding: 2px;" class="file-log-container">
      <el-tabs v-model="activeTabName" type="border-card" closable @tab-remove="handleRemoveTab" class="tabs">
        <el-tab-pane
            class="tab-pane"
            v-for="(item, index) in editableTabs"
            :key="item.name"
            :label="item.title"
            :name="item.name"
        >
          <FileLogPage :data="item.nodeData"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </page-layout>
</template>

<script>

import ServerGroup from "./group.vue";
import FileLogPage from "./filelog.vue";

export default {
  name: 'ViewMonitorFileLogWrapper',
  components: {ServerGroup, FileLogPage},
  dictTypes: [],
  data() {
    return {
      activeTabName: null,
      editableTabs: [],
    };
  },
  methods: {
    handleGroupChange(nodeData) {
      if (!nodeData) return;
      // 添加tab
      this.handleAddTab({...nodeData, tabName: 'tab_' + nodeData.id})
    },

    /**
     * 添加 tab
     * @param nodeData
     */
    handleAddTab(nodeData) {
      if(this.editableTabs.length >= 10) {
        this.$modal.msg("已达到最大tab数，最多打开10个。");
        return;
      }
      let newTable = {
        title: nodeData.logFileName,
        name: nodeData.tabName,
        nodeData: nodeData
      };
      let index = this.editableTabs.findIndex(item => item.name == newTable.name);
      if (index >= 0) {
        this.activeTabName = newTable.name;
        return;
      }
      console.log("===handleAddTab===", JSON.stringify(newTable));
      this.editableTabs.push(newTable);
      this.activeTabName = newTable.name;
    },

    /**
     * 移除 tab
     *
     * @param targetName
     */
    handleRemoveTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.activeTabName;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.activeTabName = activeName;
      this.editableTabs = tabs.filter(tab => tab.name !== targetName);
    }
  }
}
</script>

<style lang="less" scoped>
.file-log-container {
  .tabs {
    height: 100%;
  }

  :deep(.el-tabs__content) {
    height: calc(100% - 40px);

    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
